class NodeValue {
    /**
     * @param obj {Object} - данные, хранящиеся в узле
     * @param level {Number}
     * @param expanded
     * @param partiallyChosen
     * @param chosen
     * @param expandable
     */
    constructor (
        obj,
        level,
        expanded = false,
        partiallyChosen = false,
        chosen = false,
        expandable = false,
    ) {
        this.obj = obj;
        this.nodeLevel = level;
        this.isExpanded = expanded;
        this.isPartiallyChosen = partiallyChosen;
        this.isChosen = chosen;
        this.expandable = expandable;
    }
}

export default NodeValue;
